module.exports = __webpack_public_path__ + "img/Complejos.ede732ed.svg";